<template>
  <v-dialog v-model="showModal" width="500" persistent>
      <v-card>
        <v-card-title class="headline">Delete question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Are you sure to eliminate the next question?</p>
          <p><strong>{{ question.title }}</strong></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModalQuestion">No</v-btn>
          <v-btn color="primary" @click="destroyQuestion">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>

export default {
  props: {
    question: {
      type: Object
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    destroyQuestion () {
      this.$emit('delete-question');
      this.closeModalQuestion();
    },
    closeModalQuestion () {
      this.$emit('close-modal-delete');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/questions/modals/DeleteQuestion.vue